import React, { useState } from "react";
import { FormattedHTMLMessage, FormattedMessage, useIntl } from "react-intl";

import Modal from "../../../../components/Modal";
import { IconWrapper } from "../../../../components/DonateBanner/styles";
import Icon from "../../../../icon";
import { Title } from "../../../../components/Form";
import { getPaypalCode, timeago } from "../../../../../common/parameters";

import { IProps } from "./interfaces";
import messages from "./messages";
import { Modified, P } from "./styles";

const EUR = 415;

const DonationPopup = ({ onClose, donationData, donationProgress }: IProps) => {
    const [isLoading, setLoading] = useState(false);
    const { locale, formatNumber } = useIntl();
    const isHu = locale === 'hu';

    const convertAmount = (amount: number) => {
        const val = Math.floor(amount / (isHu ? 1 : EUR));
        if (isHu) return val;
        return Math.floor(val / 10) * 10;
    }
    return (
        <Modal close={onClose}>
            <IconWrapper>
                <Icon i="donate" />
            </IconWrapper>
            <Title style={{ marginTop: 16 }}>
                <FormattedMessage {...messages.title} />
            </Title>
            <P>
                <FormattedHTMLMessage {...messages.p1} values={{
                    min: formatNumber(convertAmount(donationData.min)),
                    extra: formatNumber(convertAmount(donationData.extra))
                }} />
            </P>
            {donationData.donors > 0 && (
                <P>
                    <FormattedHTMLMessage {...messages.p2} values={{
                        cost: formatNumber(convertAmount(donationData.min + donationData.extra)),
                        progress: donationProgress,
                        donors: donationData.donors,
                    }} />
                </P>
            )}
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input type="hidden" name="hosted_button_id" value={getPaypalCode(locale)} />
                <button
                    type="submit"
                    name="submit"
                    className="button button--full-width"
                    title="PayPal - The safer, easier way to pay online!"
                    onClick={() => {
                        setLoading(true);
                    }}
                    style={{
                        cursor: isLoading ? "progress" : "pointer",
                    }}
                >
                    <FormattedMessage {...messages.donate} />
                </button>
            </form>
            <Modified><FormattedMessage {...messages.modified} /> {timeago.format(donationData.latestDate, locale)}.</Modified>
        </Modal>
    );
};

export default DonationPopup;
